import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button/Button';
import { ArrowLeftIcon, ArrowRightIcon } from '../Icons/Icons';
import type { StepNavigationProps } from '../../types/ui';

export const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
  canProceed,
  onNext,
  onPrev,
  nextLabel,
  prevLabel
}) => {
  const { t } = useTranslation();
  return (
    <div className="step-navigation">
      {currentStep > 1 && (
        <Button
          variant="secondary"
          leftIcon={<ArrowLeftIcon />}
          onClick={onPrev}
        >
          {prevLabel || t('btn.back')}
        </Button>
      )}
        <div className="step-navigation__spacer" />
      
      {currentStep < 7 && (
        <Button
          variant="primary"
          rightIcon={<ArrowRightIcon />}
          onClick={onNext}
          disabled={!canProceed}
        >
          {nextLabel || t('btn.next')}
        </Button>
      )}
    </div>
  );
};